import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.entity.reviews.item');
import { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { EntityApi, EntityTree } from "src/libs/portal/review/entity";

@Component({
    selector: 'wiz-page-entity-reviews-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.entity.reviews.item/view.scss */
:host {
  --creation-canvas: #f5f6f2;
  --creation-surface: #ffffff;
  --creation-surface-muted: #f9faf7;
  --creation-ink: #242821;
  --creation-muted: #6f756c;
  --creation-subtle: #969c93;
  --creation-line: #dfe3db;
  --creation-line-strong: #ccd3c8;
  --creation-orange: #df5934;
  --creation-orange-dark: #bd4325;
  --creation-orange-soft: #fff1eb;
  --creation-olive: #667d3e;
  --creation-olive-soft: #eff4e8;
  --creation-green: #2e745d;
  --creation-green-soft: #eaf4f0;
  --creation-violet: #655781;
  --creation-violet-soft: #f0edf6;
  display: block;
  min-height: 100%;
  color: var(--creation-ink);
  font-family: Pretendard, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

button,
input {
  font: inherit;
}

button {
  border: 0;
}

.creation-page {
  min-height: 100%;
  overflow-x: hidden;
  background: var(--creation-canvas);
}

.creation-shell {
  width: min(100% - 48px, 1480px);
  margin-inline: auto;
}

.creation-header {
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid var(--creation-line);
}

.creation-heading {
  min-width: 0;
}

.creation-eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: var(--creation-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.creation-eyebrow i {
  font-size: 12px;
}

.creation-heading h1 {
  margin: 10px 0 0;
}

.creation-heading > p:last-child {
  margin: 10px 0 0;
  color: var(--creation-muted);
  font-size: 12px;
  line-height: 1.6;
}

.creation-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.creation-utility,
.creation-primary,
.row-action button,
.project-card > button,
.project-empty button,
.project-ledger__footer button,
.modal-cancel,
.modal-submit,
.project-created-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: none !important;
  cursor: pointer;
  transition: color 160ms ease, background-color 160ms ease, border-color 160ms ease, transform 160ms ease;
}

.creation-utility {
  min-height: 40px;
  gap: 8px;
  padding: 0 13px;
  color: #5f675e;
  background: #fff;
  border: 1px solid var(--creation-line);
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
}

.creation-utility:hover {
  color: var(--creation-ink);
  background: var(--creation-surface-muted);
  border-color: var(--creation-line-strong);
}

.creation-primary {
  min-height: 46px;
  gap: 9px;
  margin-left: 8px;
  padding: 0 18px;
  color: #fff;
  background: var(--creation-orange);
  box-shadow: 0 8px 18px rgba(181, 65, 34, 0.14) !important;
}

.creation-primary:hover {
  background: var(--creation-orange-dark);
  transform: translateY(-1px);
}

.creation-primary i {
  font-size: 12px;
}

.creation-overview {
  display: grid;
  grid-template-columns: minmax(250px, 1.35fr) repeat(3, minmax(170px, 1fr));
  overflow: hidden;
  background: var(--creation-surface);
  border: 1px solid var(--creation-line);
  border-radius: 13px;
  box-shadow: 0 5px 18px rgba(45, 54, 43, 0.04);
}

.creation-overview > article {
  min-width: 0;
  min-height: 118px;
  padding: 22px 24px;
}

.creation-overview > article + article {
  border-left: 1px solid var(--creation-line);
}

.creation-overview__intro {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #30352f;
}

.creation-overview__intro > span {
  color: #bfc7bb;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.creation-overview__intro strong {
  margin-top: 7px;
  color: #fff;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.creation-overview__intro p {
  max-width: 340px;
  margin: 7px 0 0;
  color: #c9cec6;
  font-size: 12px;
  line-height: 1.55;
}

.creation-metric {
  display: flex;
  align-items: center;
  gap: 14px;
}

.creation-metric__icon {
  display: grid;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  place-items: center;
  border-radius: 11px;
  font-size: 15px;
}

.creation-metric__icon.is-orange {
  color: #bd4a29;
  background: var(--creation-orange-soft);
}

.creation-metric__icon.is-violet {
  color: var(--creation-violet);
  background: var(--creation-violet-soft);
}

.creation-metric__icon.is-green {
  color: var(--creation-green);
  background: var(--creation-green-soft);
}

.creation-metric div {
  min-width: 0;
}

.creation-metric small,
.creation-metric strong,
.creation-metric p {
  display: block;
}

.creation-metric small {
  color: var(--creation-muted);
  font-size: 12px;
  font-weight: 700;
}

.creation-metric strong {
  margin-top: 3px;
  color: var(--creation-ink);
  font-size: 25px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.creation-metric p {
  margin: 7px 0 0;
  overflow: hidden;
  color: var(--creation-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.creation-path {
  display: grid;
  grid-template-columns: minmax(250px, 0.85fr) minmax(0, 2.5fr);
  align-items: stretch;
  overflow: hidden;
  background: var(--creation-surface);
  border: 1px solid var(--creation-line);
  border-radius: 13px;
  box-shadow: 0 5px 18px rgba(45, 54, 43, 0.035);
}

.creation-path__header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 22px 24px;
  background: var(--creation-surface-muted);
  border-right: 1px solid var(--creation-line);
}

.creation-path__header span,
.project-ledger__title span {
  color: var(--creation-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.creation-path__header h2 {
  margin: 6px 0 0;
  color: var(--creation-ink);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.creation-path__header > p {
  margin: 8px 0 0;
  color: var(--creation-muted);
  font-size: 12px;
  line-height: 1.55;
}

.creation-path__steps {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 0;
  padding: 0;
  list-style: none;
}

.creation-path__steps li {
  position: relative;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  grid-template-rows: auto auto;
  align-content: center;
  column-gap: 11px;
  min-width: 0;
  padding: 20px 17px;
}

.creation-path__steps li + li {
  border-left: 1px solid #ecefe9;
}

.creation-path__number {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #c5cac2;
  font-size: 12px;
  font-weight: 700;
}

.creation-path__steps li > i {
  display: grid;
  width: 34px;
  height: 34px;
  grid-row: 1/3;
  place-items: center;
  color: var(--creation-olive);
  background: var(--creation-olive-soft);
  border-radius: 9px;
  font-size: 12px;
}

.creation-path__steps strong {
  align-self: end;
  color: #343a33;
  font-size: 12px;
  font-weight: 700;
}

.creation-path__steps p {
  align-self: start;
  margin: 4px 0 0;
  color: var(--creation-subtle);
  font-size: 12px;
  line-height: 1.45;
}

.project-ledger {
  background: var(--creation-surface);
  border: 1px solid var(--creation-line);
}

.project-ledger__title {
  display: grid;
  grid-template-columns: auto auto;
  align-items: end;
  gap: 0 10px;
}

.project-ledger__title > div {
  min-width: 0;
}

.project-ledger__title h2 {
  margin: 5px 0 0;
  color: var(--creation-ink);
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.project-ledger__title > strong {
  align-self: end;
  margin-bottom: 2px;
  padding: 4px 7px;
  color: var(--creation-olive);
  background: var(--creation-olive-soft);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.project-ledger__title > p {
  grid-column: 1/-1;
  margin: 7px 0 0;
  color: var(--creation-muted);
  font-size: 12px;
}

.project-search {
  color: var(--creation-muted);
  background: #fff;
  border: 1px solid var(--creation-line-strong);
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.project-search:focus-within {
  border-color: #83976a;
}

.project-search > i {
  font-size: 12px;
}

.project-search input {
  min-width: 0;
  flex: 1;
  padding: 0;
  color: var(--creation-ink);
  box-shadow: none !important;
  font-size: 12px;
  font-weight: 600;
}

.project-search input::placeholder {
  color: #a1a69e;
}

.project-search button {
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  color: var(--creation-muted);
  background: #f1f3ef;
  cursor: pointer;
}

.project-filter-tabs {
  background: var(--creation-surface-muted);
  border-top: 1px solid #ecefe9;
  border-bottom: 1px solid var(--creation-line);
  scrollbar-width: thin;
}

.project-filter-tabs button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  gap: 7px;
  flex: 0 0 auto;
  padding: 0 11px;
  color: #747b72;
  background: transparent;
  border: 1px solid transparent;
  cursor: pointer;
  transition: color 160ms ease, background-color 160ms ease, border-color 160ms ease;
}

.project-filter-tabs button strong {
  display: grid;
  min-width: 20px;
  height: 20px;
  place-items: center;
  padding: 0 5px;
  color: #858c83;
  background: #ecefe9;
}

.project-filter-tabs button:hover {
  color: var(--creation-ink);
  background: #fff;
  border-color: var(--creation-line);
}

.project-filter-tabs button.is-active {
  color: var(--creation-orange-dark);
  background: #fff;
  border-color: #efb49f;
}

.project-filter-tabs button.is-active strong {
  color: #fff;
  background: var(--creation-orange);
}

.project-ledger__table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.project-ledger__table thead {
  background: #fff;
  border-bottom: 1px solid var(--creation-line);
}

.project-ledger__table th {
  height: 48px;
  padding: 0 13px;
  color: #858b83;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
  letter-spacing: 0.015em;
}

.project-ledger__table th:first-child,
.project-ledger__table td:first-child {
  padding-left: 24px;
}

.project-ledger__table th:last-child,
.project-ledger__table td:last-child {
  padding-right: 24px;
}

.project-ledger__table th:nth-child(1) {
  width: 19%;
}

.project-ledger__table th:nth-child(2) {
  width: 11%;
}

.project-ledger__table th:nth-child(3) {
  width: 16%;
}

.project-ledger__table th:nth-child(4) {
  width: 18%;
}

.project-ledger__table th:nth-child(5) {
  width: 11%;
}

.project-ledger__table th:nth-child(6) {
  width: 12%;
}

.project-ledger__table th:nth-child(7) {
  width: 13%;
}

.project-ledger__table tbody tr {
  height: 126px;
  background: #fff;
  border-bottom: 1px solid #e8ebe5;
  animation: row-in 0.24s ease both;
  transition: background-color 160ms ease, box-shadow 160ms ease;
}

.project-ledger__table tbody tr:hover {
  background: #fbfcf9;
  box-shadow: inset 3px 0 0 var(--creation-orange);
}

.project-ledger__table tbody tr:last-child {
  border-bottom: 0;
}

.project-ledger__table td {
  padding: 17px 13px;
  vertical-align: middle;
}

.project-cell {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  align-items: center;
  gap: 11px;
}

.project-cell__mark {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  color: #9c583e;
  background: var(--creation-orange-soft);
  border: 1px solid #f2d2c6;
  border-radius: 10px;
  font-size: 13px;
}

.project-cell__mark.is-qa {
  color: var(--creation-violet);
  background: var(--creation-violet-soft);
  border-color: #ddd6e8;
}

.project-cell__mark.is-kg {
  color: var(--creation-green);
  background: var(--creation-green-soft);
  border-color: #cfe1da;
}

.project-cell > div > strong,
.project-cell > div > span,
.project-cell > div > p,
.target-cell small,
.state-cell strong,
.state-cell small,
.readiness-cell small,
.project-status strong,
.project-status small,
.update-cell strong,
.update-cell small {
  display: block;
}

.project-cell > div {
  min-width: 0;
}

.project-cell > div > strong {
  overflow: hidden;
  color: #2b302a;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-cell > div > span {
  margin-top: 5px;
  color: var(--creation-muted);
  font-size: 12px;
  font-weight: 700;
}

.project-cell > div > p {
  overflow: hidden;
  margin: 5px 0 0;
  color: var(--creation-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.target-badge {
  display: inline-flex;
  min-width: 48px;
  min-height: 28px;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
  color: #676e66;
  background: #eef0ed;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
}

.target-badge.is-qa {
  color: var(--creation-violet);
  background: var(--creation-violet-soft);
}

.target-badge.is-kg {
  color: var(--creation-green);
  background: var(--creation-green-soft);
}

.target-badge.is-both {
  color: #a44728;
  background: var(--creation-orange-soft);
}

.target-cell small {
  margin-top: 7px;
  color: var(--creation-subtle);
  font-size: 12px;
  line-height: 1.45;
}

.source-dataset-cell {
  min-width: 0;
}

.state-cell strong {
  overflow: hidden;
  color: var(--creation-muted);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.state-cell strong i {
  margin-right: 6px;
}

.state-cell.is-ready strong {
  color: var(--creation-green);
}

.state-cell.is-alert strong {
  color: #b54627;
}

.state-cell.is-waiting strong {
  color: var(--creation-muted);
}

.state-cell small {
  margin-top: 5px;
  overflow: hidden;
  color: var(--creation-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 9px;
}

.dataset-tags span {
  padding: 4px 6px;
  color: #6f756c;
  background: #f1f3ef;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 700;
}

.readiness-cell > div:first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.readiness-cell > div:first-child strong {
  overflow: hidden;
  color: #4c534b;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.readiness-cell > div:first-child span {
  color: var(--creation-olive);
  font-size: 12px;
  font-weight: 700;
}

.readiness-bar {
  height: 5px;
  margin-top: 9px;
  overflow: hidden;
  background: #e8ebe5;
  border-radius: 999px;
}

.readiness-bar > span {
  display: block;
  height: 100%;
  min-width: 5px;
  background: var(--creation-orange);
  border-radius: inherit;
  transition: width 220ms ease;
}

.readiness-bar > span.is-complete {
  background: var(--creation-green);
}

.readiness-bar > span.is-review {
  background: var(--creation-violet);
}

.readiness-bar > span.is-alert {
  background: #c9502e;
}

.readiness-bar > span.is-progress {
  background: var(--creation-olive);
}

.readiness-cell small {
  margin-top: 7px;
  overflow: hidden;
  color: var(--creation-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-status strong {
  color: var(--creation-muted);
  font-size: 12px;
  font-weight: 700;
}

.project-status strong i {
  display: inline-block;
  width: 7px;
  height: 7px;
  margin-right: 7px;
  border-radius: 999px;
  background: #9da39b;
}

.project-status.is-complete strong {
  color: var(--creation-green);
}

.project-status.is-complete strong i {
  background: var(--creation-green);
}

.project-status.is-alert strong {
  color: #b54627;
}

.project-status.is-alert strong i {
  background: var(--creation-orange);
}

.project-status.is-review strong {
  color: var(--creation-violet);
}

.project-status.is-review strong i {
  background: var(--creation-violet);
}

.project-status.is-progress strong {
  color: #7a6237;
}

.project-status.is-progress strong i {
  background: #bd8b35;
}

.project-status small {
  margin-top: 7px;
  overflow: hidden;
  color: var(--creation-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.update-cell {
  min-width: 0;
}

.update-cell strong {
  overflow: hidden;
  color: #596058;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row-action {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.row-action__primary {
  min-height: 36px;
  gap: 8px;
  padding: 0 12px;
  color: #fff;
  background: #343934;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.row-action__primary:hover {
  background: var(--creation-orange);
}

.row-action__delete {
  min-height: 36px;
  gap: 6px;
  padding: 0 10px;
  color: #a64e3d;
  background: #fff;
  border: 1px solid #e6c5bd;
  white-space: nowrap;
}

.row-action__delete:hover:not(:disabled) {
  color: #8d3d2f;
  background: #fff4f1;
  border-color: #d58b7a;
}

.row-action__delete:disabled {
  color: #aeb5b1;
  background: #f5f6f5;
  border-color: #e1e5e2;
  cursor: wait;
}

.project-empty {
  display: grid;
  min-height: 300px;
  place-items: center;
  align-content: center;
  gap: 8px;
  color: var(--creation-subtle);
  text-align: center;
}

.project-empty > span {
  display: grid;
  width: 48px;
  height: 48px;
  margin-bottom: 4px;
  place-items: center;
  color: var(--creation-olive);
  background: var(--creation-olive-soft);
  border-radius: 12px;
  font-size: 18px;
}

.project-empty strong {
  color: #4f574e;
  font-size: 13px;
}

.project-empty p {
  margin: 0;
  font-size: 12px;
}

.project-empty button {
  min-height: 36px;
  margin-top: 7px;
  padding: 0 13px;
  color: #fff;
  background: #343934;
}

.project-ledger__footer {
  color: var(--creation-muted);
  background: var(--creation-surface-muted);
  border-top: 1px solid var(--creation-line);
}

.project-ledger__footer > strong {
  color: #596058;
  font-weight: 700;
}

.project-ledger__footer > span {
  justify-self: end;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 6px;
}

.pagination button {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  color: var(--creation-muted);
  background: #fff;
  border: 1px solid var(--creation-line);
}

.pagination button.is-active {
  color: #fff;
  background: var(--creation-orange);
  border-color: var(--creation-orange);
}

.pagination button:disabled {
  color: #c3c8c1;
  background: #f1f3ef;
  cursor: default;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

.project-modal-backdrop,
.project-created-backdrop {
  position: fixed;
  inset: 0;
  z-index: 110;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(31, 36, 31, 0.66);
  backdrop-filter: blur(7px);
}

.project-modal,
.project-created-modal {
  width: min(620px, 100%);
  overflow: hidden;
  background: #fff;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 16px;
  box-shadow: 0 28px 80px rgba(20, 26, 20, 0.28);
  animation: modal-in 180ms ease both;
}

.project-modal > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 26px 28px 23px;
  background: var(--creation-surface-muted);
  border-bottom: 1px solid var(--creation-line);
}

.project-modal__heading > span,
.project-created-modal__body > p:first-of-type {
  display: flex;
  align-items: center;
  gap: 7px;
  color: var(--creation-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.project-modal > header h2 {
  margin: 8px 0 0;
  color: var(--creation-ink);
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.project-modal > header p {
  max-width: 470px;
  margin: 8px 0 0;
  color: var(--creation-muted);
  font-size: 12px;
  line-height: 1.55;
}

.project-modal > header > button {
  display: grid;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  place-items: center;
  color: var(--creation-muted);
  background: #fff;
  border: 1px solid var(--creation-line);
  cursor: pointer;
}

.project-modal > header > button:hover {
  color: var(--creation-ink);
  border-color: var(--creation-line-strong);
}

.modal-body {
  display: grid;
  gap: 22px;
  padding: 25px 28px;
}

.field > span,
.output-choice > span {
  display: block;
  margin-bottom: 9px;
  color: #525a51;
  font-size: 12px;
  font-weight: 700;
}

.field > input {
  width: 100%;
  min-height: 46px;
  padding: 0 13px;
  color: var(--creation-ink);
  background: #fff;
  border: 1px solid var(--creation-line-strong) !important;
  border-radius: 8px;
  outline: 0;
  box-shadow: none !important;
  font-size: 12px;
  font-weight: 700;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.field > input:focus {
  border-color: #83976a !important;
  box-shadow: 0 0 0 3px rgba(102, 125, 62, 0.1) !important;
}

.field > small {
  display: block;
  margin-top: 7px;
  color: var(--creation-subtle);
  font-size: 12px;
}

.output-choice {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.output-choice > span {
  grid-column: 1/-1;
}

.output-choice label {
  position: relative;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) 24px;
  min-height: 88px;
  align-items: center;
  gap: 11px;
  padding: 14px;
  background: var(--creation-surface-muted);
  border: 1px solid var(--creation-line);
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.output-choice label:hover {
  border-color: var(--creation-line-strong);
}

.output-choice label.is-checked {
  background: #fffaf7;
  border-color: #eca98f;
  box-shadow: 0 0 0 3px rgba(223, 89, 52, 0.07);
}

.output-choice label.is-disabled {
  color: #8d948c;
  background: #f3f4f1;
  border-color: #dfe3dd;
  cursor: not-allowed;
}

.output-choice label.is-disabled:hover {
  border-color: #dfe3dd;
}

.output-choice label.is-disabled .output-choice__icon,
.output-choice label.is-disabled .output-choice__check {
  color: #959c94;
  background: #e5e8e3;
}

.output-choice input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.output-choice__icon {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border-radius: 10px;
  font-size: 14px;
}

.output-choice__icon.is-qa {
  color: var(--creation-violet);
  background: var(--creation-violet-soft);
}

.output-choice__icon.is-kg {
  color: var(--creation-green);
  background: var(--creation-green-soft);
}

.output-choice label > div {
  min-width: 0;
}

.output-choice strong,
.output-choice small {
  display: block;
}

.output-choice strong {
  color: #343a33;
  font-size: 12px;
  font-weight: 700;
}

.output-choice small {
  margin-top: 5px;
  color: var(--creation-muted);
  font-size: 12px;
  line-height: 1.4;
}

.output-choice small.output-choice__preparing {
  color: #7c837b;
  font-weight: 700;
}

.output-choice__check {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  color: #fff;
  background: #d4d9d2;
  border-radius: 6px;
  font-size: 12px;
}

.output-choice label.is-checked .output-choice__check {
  background: var(--creation-orange);
}

.contract-note {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  align-items: start;
  gap: 12px;
  padding: 16px;
  color: var(--creation-muted);
  background: var(--creation-olive-soft);
  border: 1px solid #dce5d2;
  border-radius: 10px;
}

.contract-note__icon {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  color: var(--creation-olive);
  background: rgba(102, 125, 62, 0.1);
  border-radius: 8px;
  font-size: 12px;
}

.contract-note__copy {
  min-width: 0;
}

.contract-note strong {
  display: block;
  color: #4c5c3d;
  font-size: 12px;
  line-height: 1.4;
}

.contract-note p {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.5;
}

.contract-note__status {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding: 6px 9px;
  color: #687067;
  background: rgba(255, 255, 255, 0.62);
  border: 1px solid rgba(102, 125, 62, 0.14);
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
}

.contract-note__status i {
  flex: 0 0 auto;
  color: #7d8876;
  font-size: 12px;
}

.project-modal > footer,
.project-created-modal > footer {
  display: flex;
  min-height: 76px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 28px;
  background: var(--creation-surface-muted);
  border-top: 1px solid var(--creation-line);
}

.project-modal > footer > div {
  display: flex;
  margin-left: auto;
  gap: 8px;
}

.modal-cancel,
.modal-submit,
.project-created-action {
  min-height: 42px;
  padding: 0 16px;
}

.modal-cancel {
  color: #5c645b;
  background: #fff;
  border: 1px solid var(--creation-line);
}

.modal-cancel:hover {
  background: #f1f3ef;
}

.modal-submit,
.project-created-action {
  gap: 9px;
  color: #fff;
  background: var(--creation-orange);
}

.modal-submit:hover,
.project-created-action:hover {
  background: var(--creation-orange-dark);
}

.modal-submit:disabled {
  color: #a7aca5;
  background: #e3e6e1;
  cursor: not-allowed;
}

.project-created-modal {
  max-width: 460px;
  text-align: center;
}

.project-created-modal__body {
  padding: 38px 32px 30px;
}

.project-created-modal__icon {
  display: grid;
  width: 54px;
  height: 54px;
  margin: 0 auto 17px;
  place-items: center;
  color: #fff;
  background: var(--creation-green);
  border-radius: 50%;
  box-shadow: 0 9px 22px rgba(46, 116, 93, 0.18);
  font-size: 17px;
}

.project-created-modal__body > p:first-of-type {
  justify-content: center;
  margin: 0;
}

.project-created-modal__body h2 {
  margin: 8px 0 0;
  color: var(--creation-ink);
  font-size: 23px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.project-created-modal__body > p:last-of-type {
  margin: 9px 0 0;
  color: var(--creation-muted);
  font-size: 12px;
  line-height: 1.55;
}

.project-created-summary {
  margin-top: 22px;
  padding: 15px;
  text-align: left;
  background: var(--creation-surface-muted);
  border: 1px solid var(--creation-line);
  border-radius: 10px;
}

.project-created-summary > span,
.project-created-summary > strong {
  display: block;
}

.project-created-summary > span {
  color: var(--creation-subtle);
  font-size: 12px;
}

.project-created-summary > strong {
  margin-top: 5px;
  color: #343a33;
  font-size: 12px;
}

.project-created-summary > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.project-created-summary em {
  padding: 5px 8px;
  color: #a44728;
  background: var(--creation-orange-soft);
  border-radius: 5px;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.project-created-modal > footer {
  justify-content: center;
}

@keyframes row-in {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes modal-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 1280px) {
  .creation-overview {
    grid-template-columns: minmax(230px, 1.2fr) repeat(3, minmax(150px, 1fr));
  }
  .project-ledger__table th:nth-child(6),
  .project-ledger__table td:nth-child(6) {
    display: none;
  }
  .project-ledger__table th:nth-child(1) {
    width: 22%;
  }
  .project-ledger__table th:nth-child(2) {
    width: 12%;
  }
  .project-ledger__table th:nth-child(3) {
    width: 19%;
  }
  .project-ledger__table th:nth-child(4) {
    width: 22%;
  }
  .project-ledger__table th:nth-child(5) {
    width: 13%;
  }
  .project-ledger__table th:nth-child(7) {
    width: 12%;
  }
}
@media (max-width: 1040px) {
  .creation-overview {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .creation-overview__intro {
    grid-column: 1/-1;
    min-height: 104px !important;
  }
  .creation-overview > article:nth-child(2) {
    border-left: 0;
  }
  .creation-path {
    grid-template-columns: 1fr;
  }
  .creation-path__header {
    border-right: 0;
    border-bottom: 1px solid var(--creation-line);
  }
  .project-ledger__table th:nth-child(3),
  .project-ledger__table td:nth-child(3) {
    display: none;
  }
  .project-ledger__table th:nth-child(1) {
    width: 27%;
  }
  .project-ledger__table th:nth-child(2) {
    width: 14%;
  }
  .project-ledger__table th:nth-child(4) {
    width: 27%;
  }
  .project-ledger__table th:nth-child(5) {
    width: 16%;
  }
  .project-ledger__table th:nth-child(7) {
    width: 16%;
  }
}
@media (max-width: 820px) {
  .creation-header__actions {
    width: 100%;
  }
  .creation-primary {
    margin-left: auto;
  }
  .creation-overview {
    grid-template-columns: 1fr;
  }
  .creation-overview__intro {
    grid-column: auto;
  }
  .creation-overview > article + article {
    border-top: 1px solid var(--creation-line);
    border-left: 0;
  }
  .creation-metric {
    min-height: 96px !important;
  }
  .creation-path__steps {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .creation-path__steps li:nth-child(3) {
    border-left: 0;
  }
  .creation-path__steps li:nth-child(n+3) {
    border-top: 1px solid #ecefe9;
  }
  .project-card-list {
    background: #f1f3ef;
  }
  .project-card {
    padding: 18px;
    background: #fff;
    border: 1px solid var(--creation-line);
    border-radius: 11px;
    animation: row-in 0.24s ease both;
  }
  .project-card header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }
  .project-card__identity {
    display: grid;
    grid-template-columns: 38px minmax(0, 1fr);
    align-items: center;
    gap: 11px;
    min-width: 0;
  }
  .project-card__identity > div {
    min-width: 0;
  }
  .project-card__identity strong,
  .project-card__identity span {
    display: block;
  }
  .project-card__identity strong {
    overflow: hidden;
    color: var(--creation-ink);
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .project-card__identity span {
    margin-top: 5px;
    color: var(--creation-muted);
    font-size: 12px;
  }
  .project-card__progress {
    margin-top: 18px;
  }
  .project-card__progress > div:first-child {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    color: #50584f;
    font-size: 12px;
  }
  .project-card__progress p {
    margin: 7px 0 0;
    color: var(--creation-subtle);
    font-size: 12px;
  }
  .project-card dl {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin: 16px 0 0;
  }
  .project-card dl div {
    padding: 11px;
    background: var(--creation-surface-muted);
    border-radius: 8px;
  }
  .project-card dt {
    color: var(--creation-subtle);
    font-size: 12px;
    font-weight: 700;
  }
  .project-card dd {
    margin: 5px 0 0;
    color: #4f574e;
    font-size: 12px;
    font-weight: 700;
  }
  .project-card__actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px;
    margin-top: 14px;
  }
  .project-card__actions button {
    min-height: 42px;
    gap: 9px;
  }
  .project-card__open {
    width: 100%;
    color: #fff;
    background: #343934;
  }
  .project-card__delete {
    min-width: 76px;
    padding: 0 13px;
    color: #a64e3d;
    background: #fff;
    border: 1px solid #e6c5bd;
  }
  .project-card__delete:disabled {
    color: #aeb5b1;
    background: #f5f6f5;
    border-color: #e1e5e2;
    cursor: wait;
  }
}
@media (max-width: 560px) {
  .creation-shell {
    width: min(100% - 24px, 1480px);
  }
  .creation-header__actions {
    flex-wrap: wrap;
  }
  .creation-utility {
    display: none;
  }
  .creation-primary {
    width: 100%;
    margin: 0;
  }
  .creation-path__steps {
    grid-template-columns: 1fr;
  }
  .creation-path__steps li + li,
  .creation-path__steps li:nth-child(3) {
    border-top: 1px solid #ecefe9;
    border-left: 0;
  }
  .project-ledger__footer .pagination {
    display: none;
  }
  .project-card header {
    align-items: flex-start;
  }
  .project-card dl {
    grid-template-columns: 1fr;
  }
  .output-choice {
    grid-template-columns: 1fr;
  }
  .project-modal-backdrop,
  .project-created-backdrop {
    align-items: end;
    padding: 10px;
  }
  .project-modal,
  .project-created-modal {
    max-height: calc(100vh - 20px);
    overflow-y: auto;
    border-radius: 14px;
  }
  .project-modal > header,
  .project-created-modal__body,
  .modal-body {
    padding-inline: 20px;
  }
  .project-modal > footer,
  .project-created-modal > footer {
    padding-inline: 20px;
  }
  .project-modal > footer > div {
    width: 100%;
  }
  .project-modal > footer button {
    flex: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .project-ledger__table tbody tr,
  .project-card,
  .project-modal,
  .project-created-modal {
    animation: none;
  }
  .creation-utility,
  .creation-primary,
  .project-filter-tabs button,
  .row-action button,
  .readiness-bar > span {
    transition: none;
  }
}
/* Unified operations header ------------------------------------------------ */
.creation-header .creation-header__inner {
  box-sizing: border-box;
}

.creation-heading {
  display: grid;
  gap: 5px;
  min-width: 0;
}

.creation-eyebrow {
  width: fit-content;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
  line-height: 1.2;
}

.creation-heading .reviewops-page-title {
  margin: 0;
}

.creation-heading > p:last-child {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.45;
}

.creation-header__actions {
  align-self: center;
  margin-left: auto;
}

.creation-primary {
  min-height: 42px;
  margin-left: 0;
  padding: 0 19px;
}

@media (max-width: 920px) {
  .creation-header__actions {
    width: 100%;
    align-self: stretch;
    margin-left: 0;
  }
  .creation-primary {
    width: 100%;
  }
}
/* Brighter project workspace surfaces ------------------------------------- */
.creation-page {
  --creation-surface: #ffffff;
  --creation-surface-muted: #fbfcfa;
}

.creation-page .creation-overview,
.creation-page .creation-path,
.creation-page .project-ledger,
.creation-page .project-card,
.creation-page .creation-path__header,
.creation-page .project-ledger__header,
.creation-page .project-filter-tabs {
  background: #ffffff !important;
}

.creation-page .creation-overview,
.creation-page .creation-path,
.creation-page .project-ledger,
.creation-page .project-card {
  border-color: #e3e7e1 !important;
}

.creation-page .creation-overview__intro {
  color: var(--creation-ink);
  background: #fff7f2 !important;
  box-shadow: inset 4px 0 0 var(--creation-orange);
}

.creation-page .creation-overview__intro > span {
  color: var(--creation-orange);
}

.creation-page .creation-overview__intro strong {
  color: var(--creation-ink);
}

.creation-page .creation-overview__intro p {
  color: var(--creation-muted);
}

/* Keep the primary list action beside search instead of in the page header. */
:host-context(.reviewops-shell) .creation-page .project-ledger__controls .project-search {
  justify-self: end;
}

:host-context(.reviewops-shell) .creation-page .creation-primary--ledger {
  width: auto !important;
  min-height: 42px;
  margin: 0 !important;
  padding-inline: 16px;
  white-space: nowrap;
}

@media (max-width: 920px) {
  :host-context(.reviewops-shell) .creation-page .creation-primary--ledger {
    width: 100% !important;
  }
}
/* The footer owns the final divider; avoid a second line from the last row. */
:host-context(.reviewops-shell) .creation-page .project-ledger__table tbody > tr:last-child > td {
  border-bottom: 0 !important;
}

/* QA list only: entity pages import this file, so every added rule requires this root. */
:host-context(.reviewops-shell) .qa-project-list .project-ledger__table th {
  width: auto;
}
:host-context(.reviewops-shell) .qa-project-list .project-ledger__table th,
:host-context(.reviewops-shell) .qa-project-list .project-ledger__table td {
  display: table-cell;
}
:host-context(.reviewops-shell) .qa-project-list .project-ledger__column--metadata {
  width: 180px;
}
:host-context(.reviewops-shell) .qa-project-list .project-ledger__column--actions {
  width: 164px;
}
:host-context(.reviewops-shell) .qa-project-list .target-cell {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  margin-top: 12px;
}
:host-context(.reviewops-shell) .qa-project-list .target-cell small {
  margin: 0;
}
:host-context(.reviewops-shell) .qa-project-list .source-dataset-cell {
  margin-top: 12px;
}
:host-context(.reviewops-shell) .qa-project-list .project-status {
  margin-top: 16px;
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata {
  display: grid;
  gap: 12px;
  margin: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata dt {
  color: var(--creation-muted);
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata dd {
  margin: 4px 0 0;
  color: var(--creation-ink);
  font-weight: 600;
}
:host-context(.reviewops-shell) .qa-project-list .row-action {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  min-width: 0;
  justify-items: stretch;
  gap: 8px;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell > div > strong,
:host-context(.reviewops-shell) .qa-project-list .project-cell > div > span,
:host-context(.reviewops-shell) .qa-project-list .project-cell > div > p,
:host-context(.reviewops-shell) .qa-project-list .state-cell strong,
:host-context(.reviewops-shell) .qa-project-list .state-cell small,
:host-context(.reviewops-shell) .qa-project-list .readiness-cell > div:first-child strong,
:host-context(.reviewops-shell) .qa-project-list .readiness-cell small,
:host-context(.reviewops-shell) .qa-project-list .project-status small,
:host-context(.reviewops-shell) .qa-project-list .project-metadata dd,
:host-context(.reviewops-shell) .qa-project-list .project-card__identity strong,
:host-context(.reviewops-shell) .qa-project-list .project-card__identity span,
:host-context(.reviewops-shell) .qa-project-list .project-card dd {
  overflow: visible;
  white-space: normal;
  text-overflow: clip;
  word-break: normal;
  overflow-wrap: anywhere;
}
:host-context(.reviewops-shell) .qa-project-list .readiness-cell > div:first-child {
  flex-wrap: wrap;
}
:host-context(.reviewops-shell) .qa-project-list .row-action > a,
:host-context(.reviewops-shell) .qa-project-list .row-action > button,
:host-context(.reviewops-shell) .qa-project-list .project-card__actions > a,
:host-context(.reviewops-shell) .qa-project-list .project-card__actions > button {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding-inline: 12px;
  white-space: nowrap;
  overflow-wrap: normal;
}
:host-context(.reviewops-shell) .qa-project-list .row-action i,
:host-context(.reviewops-shell) .qa-project-list .project-card__actions i {
  flex: 0 0 auto;
}
@media (max-width: 1023px) {
  :host-context(.reviewops-shell) .qa-project-list .project-card-list {
    background: #f1f3ef;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card {
    padding: 18px;
    background: #fff;
    border: 1px solid var(--creation-line);
    border-radius: 11px;
    animation: row-in 0.24s ease both;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity {
    display: grid;
    grid-template-columns: 38px minmax(0, 1fr);
    align-items: center;
    gap: 11px;
    min-width: 0;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity > div {
    min-width: 0;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity strong,
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity span {
    display: block;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity strong {
    overflow: hidden;
    color: var(--creation-ink);
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity span {
    margin-top: 5px;
    color: var(--creation-muted);
    font-size: 12px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__progress {
    margin-top: 18px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__progress > div:first-child {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    color: #50584f;
    font-size: 12px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__progress p {
    margin: 7px 0 0;
    color: var(--creation-subtle);
    font-size: 12px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card dl {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin: 16px 0 0;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card dl div {
    padding: 11px;
    background: var(--creation-surface-muted);
    border-radius: 8px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card dt {
    color: var(--creation-subtle);
    font-size: 12px;
    font-weight: 700;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card dd {
    margin: 5px 0 0;
    color: #4f574e;
    font-size: 12px;
    font-weight: 700;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px;
    margin-top: 14px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__actions button {
    min-height: 42px;
    gap: 9px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__open {
    width: 100%;
    color: #fff;
    background: #343934;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__delete {
    min-width: 76px;
    padding: 0 13px;
    color: #a64e3d;
    background: #fff;
    border: 1px solid #e6c5bd;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__delete:disabled {
    color: #aeb5b1;
    background: #f5f6f5;
    border-color: #e1e5e2;
    cursor: wait;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity strong,
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity span,
  :host-context(.reviewops-shell) .qa-project-list .project-card dd {
    overflow: visible;
    white-space: normal;
    text-overflow: clip;
    overflow-wrap: anywhere;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 92px;
    gap: 8px;
  }
}
@media (max-width: 560px) {
  :host-context(.reviewops-shell) .qa-project-list .project-card dl {
    grid-template-columns: 1fr;
  }
}

/* 11: workspace information hierarchy and shared component roles. */
:host-context(.reviewops-shell) .qa-project-list .project-ledger__title p {
  margin: 0;
}
:host-context(.reviewops-shell) .qa-project-list .qa-list-filters {
  border-bottom: 1px solid var(--ro-line);
}
:host-context(.reviewops-shell) .qa-project-list .qa-list-filters > summary {
  min-height: 44px;
  padding: 10px 16px;
  cursor: pointer;
  color: var(--ro-ink);
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
}
:host-context(.reviewops-shell) .qa-project-list .qa-project-details {
  margin-top: 8px;
}
:host-context(.reviewops-shell) .qa-project-list .qa-project-details > summary {
  cursor: pointer;
  min-height: 44px;
  padding-block: 10px;
  color: var(--ro-accent);
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  align-items: start;
  gap: 12px;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell__mark {
  position: static;
  display: grid;
  place-items: center;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  margin: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell__mark > i {
  position: static;
  margin: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell > div {
  min-width: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell > div > strong, :host-context(.reviewops-shell) .qa-project-list .project-card__identity strong {
  word-break: keep-all;
}
:host-context(.reviewops-shell) .qa-project-list .target-cell, :host-context(.reviewops-shell) .qa-project-list .source-dataset-cell, :host-context(.reviewops-shell) .qa-project-list .project-status {
  margin-top: 4px;
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata {
  gap: 4px;
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata > div {
  display: flex;
  flex-wrap: wrap;
  gap: 0 8px;
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata dd {
  margin-top: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-card__state {
  display: grid;
  gap: 4px;
  margin: 12px 0;
  font-size: 14px;
  line-height: 22px;
}
:host-context(.reviewops-shell) .qa-project-list .project-card__state strong {
  color: var(--ro-ink);
}
:host-context(.reviewops-shell) .qa-project-list .project-card__state span {
  color: var(--ro-muted);
}
:host-context(.reviewops-shell) .qa-project-list .project-card__identity {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  gap: 12px;
  align-items: start;
}
:host-context(.reviewops-shell) .qa-project-list .project-card__identity > .project-cell__mark {
  grid-column: 1;
  grid-row: 1;
}
:host-context(.reviewops-shell) .qa-project-list .project-card__identity > div {
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-card dl {
  margin-top: 8px;
}
:host-context(.reviewops-shell) .qa-project-list .project-card dl > div {
  padding: 8px 0;
  background: transparent;
  border-bottom: 1px solid var(--ro-line);
  border-radius: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-card__actions {
  margin-top: 8px;
}
@media (max-width: 639px) {
  :host-context(.reviewops-shell) .qa-project-list .qa-list-filters > summary {
    padding-inline: 16px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card {
    padding: 16px;
    border-radius: 12px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card header {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 8px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card header > .target-badge {
    justify-self: start;
  }
}

.entity-page {
  color: #30372f;
  min-height: 100%;
  background: #f7f8f4;
}

.entity-page *, .entity-page *::before, .entity-page *::after {
  box-sizing: border-box;
}

.e-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid #d9dfd5;
  border-radius: 8px;
  background: #fff;
  padding: 10px 14px;
  min-height: 40px;
  color: #394035;
  font: inherit;
  font-size: 13px;
  font-weight: 650;
  text-decoration: none;
  cursor: pointer;
}

.e-button:hover {
  background: #f2f5ec;
  border-color: #aab79a;
}

.e-button--primary {
  background: #3b4237;
  color: #fff;
  border-color: #3b4237;
}

.e-button--primary:hover {
  background: #525d45;
  color: #fff;
}

.e-button:disabled, .e-text-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.entity-page button:focus-visible, .entity-page a:focus-visible, .entity-page input:focus-visible, .entity-page select:focus-visible, .entity-page textarea:focus-visible {
  outline: 3px solid #ef603b;
  outline-offset: 3px;
}

.e-text-button {
  border: 0;
  background: transparent;
  color: #a2452c;
  padding: 8px;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}

.e-back {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  font-size: 12px;
  color: #697561;
  text-decoration: none;
  margin-bottom: 14px;
}

.e-item-link {
  color: #30372f;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
}

.e-item-link:hover {
  color: #b34429;
  text-decoration: underline;
}

.e-notice, .e-error {
  padding: 14px 18px;
  border-radius: 9px;
  margin: 0 0 18px;
  line-height: 1.7;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.e-notice {
  color: #775c25;
  border: 1px solid #ecdfbd;
  background: #fffaf0;
}

.e-error {
  color: #9c3529;
  border: 1px solid #edc9c2;
  background: #fff5f2;
}

.e-error p, .e-notice p {
  margin: 4px 0;
}

.e-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 24px;
}

.e-metrics article {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 24px;
  background: #fff;
  border: 1px solid #e1e5dc;
  border-radius: 12px;
}

.e-metrics span {
  font-size: 12px;
  color: #74806b;
}

.e-metrics strong {
  font-size: 27px;
  letter-spacing: -0.5px;
}

.e-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 6px;
  padding: 5px 8px;
  background: #edf3e6;
  color: #596c40;
  font-size: 12px;
  font-weight: 650;
  white-space: normal;
}

.e-badge--muted {
  background: #f1f1eb;
  color: #777d70;
}

.e-subtext {
  display: block;
  margin-top: 5px;
  font-size: 12px;
  color: #7d8777;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.e-muted {
  font-size: 12px;
  color: #7a8473;
  line-height: 1.75;
  margin: 12px 0;
  overflow-wrap: anywhere;
}

.e-empty {
  padding: 34px 20px;
  text-align: center;
  color: #7b8573;
  font-size: 13px;
  line-height: 1.8;
}

.e-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 18px 22px;
  border-top: 1px solid #e7eae3;
  font-size: 12px;
  color: #79836f;
}

.e-pagination > div {
  display: flex;
  align-items: center;
  gap: 14px;
}

.e-project-table {
  min-width: 650px;
}

.e-project-table th, .e-project-table td {
  display: table-cell !important;
}

.e-project-table th:nth-child(1) {
  width: 36% !important;
}

.e-project-table th:nth-child(2) {
  width: 12% !important;
}

.e-project-table th:nth-child(3) {
  width: 20% !important;
}

.e-project-table th:nth-child(4) {
  width: 19% !important;
}

.e-project-table th:nth-child(5) {
  width: 13% !important;
}

.e-list-cards {
  display: none;
}

.e-list-card {
  padding: 18px;
  border-bottom: 1px solid #e7ebdf;
}

.e-list-card__status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  font-size: 12px;
}

.e-list-card > .e-button {
  margin-top: 12px;
  width: 100%;
}

.e-card {
  min-width: 0;
  border: 1px solid #e1e5dc;
  border-radius: 12px;
  background: #fff;
  padding: 24px;
  margin-bottom: 22px;
}

.e-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}

.e-card h2 {
  font-size: 18px;
  margin: 0;
  font-weight: 750;
}

.e-card h3 {
  font-size: 16px;
  line-height: 1.7;
  overflow-wrap: anywhere;
}

.e-card h4 {
  font-size: 13px;
  font-weight: 700;
  margin: 12px 0;
}

.e-eyebrow {
  font-size: 12px;
  letter-spacing: 1.4px;
  color: #db5b36;
  display: block;
  margin-bottom: 8px;
}

.e-description {
  font-size: 13px;
  line-height: 1.8;
  color: #66715e;
  margin-bottom: 14px;
}

.e-source-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.e-source-list article {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8f9f5;
  border-radius: 8px;
  font-size: 12px;
}

.e-source-list article > div {
  min-width: 0;
  overflow-wrap: anywhere;
}

.e-source-list .e-badge {
  flex-shrink: 0;
}

.e-two-panel {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
  align-items: start;
  gap: 22px;
}

.e-tree {
  max-height: 540px;
  overflow: auto;
  margin: 12px -10px 0;
}

.e-tree-row {
  display: flex;
  align-items: flex-start;
  border-radius: 6px;
  padding-top: 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid #f0f2ec;
}

.e-tree-row.is-selected {
  background: #fff1e9;
}

.e-tree-toggle {
  flex: 0 0 26px;
  width: 26px;
  height: 32px;
  border: 0;
  background: none;
  font-size: 12px;
  color: #78846c;
  cursor: pointer;
}

.e-tree-toggle:disabled {
  opacity: 0.35;
  cursor: default;
}

.e-tree-title {
  text-align: left;
  border: 0;
  background: none;
  padding: 5px;
  flex: 1;
  min-width: 0;
  cursor: pointer;
  color: #394232;
}

.e-tree-title strong {
  font-size: 12px;
  line-height: 1.7;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.e-tree-title small {
  display: block;
  font-size: 12px;
  color: #87917d;
  line-height: 1.7;
  margin-top: 4px;
}

.e-search {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #dce2d6;
  padding: 10px 12px;
  border-radius: 8px;
  color: #839077;
}

.e-search input {
  min-width: 0;
  width: 100%;
  border: 0;
  outline: none;
  background: none;
  font-size: 12px;
}

.e-analysis {
  margin: 20px 0;
}

.e-analysis > div {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #edf0e7;
  padding: 12px 0;
  font-size: 13px;
}

.e-analysis dt {
  color: #7b8671;
}

.e-type-list {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin: 9px 0 18px;
}

.e-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 14px 0;
  font-size: 12px;
  color: #6a765e;
}

.e-field input, .e-field select, .e-field textarea, .e-filters input, .e-filters select {
  width: 100%;
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid #dce2d6;
  border-radius: 7px;
  background: #fff;
  color: #3d4636;
  font: inherit;
  font-size: 12px;
}

.e-field textarea {
  resize: vertical;
}

.e-reviewer-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.e-reviewer-grid > label {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px;
  border: 1px solid #e5e9df;
  border-radius: 8px;
  cursor: pointer;
}

.e-reviewer-grid input {
  accent-color: #778c35;
  margin-top: 4px;
}

.e-reviewer-grid strong {
  font-size: 13px;
}

.e-reviewer-grid small {
  display: block;
  color: #8c9582;
  font-size: 12px;
  margin-top: 6px;
  overflow-wrap: anywhere;
}

.e-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.e-job {
  margin-top: 18px;
  border-radius: 8px;
  background: #f4f7ee;
  padding: 14px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.e-job progress {
  width: 100%;
  accent-color: #8ca13c;
}

.e-history {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
  border-top: 1px solid #eef0e9;
  font-size: 12px;
}

.e-history > span {
  color: #859078;
}

.e-result-main {
  max-width: 2100px;
  padding: 22px;
  margin: 0 auto;
}

.e-workbench {
  display: grid;
  grid-template-columns: minmax(230px, 0.75fr) minmax(320px, 1.45fr) minmax(300px, 1fr);
  align-items: start;
  gap: 16px;
}

.e-workbench .e-card {
  padding: 18px;
}

.e-workbench .e-tree {
  max-height: 74vh;
}

.e-source-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  line-height: 28px;
  font-size: 16px;
  max-height: 64vh;
  overflow-y: auto;
  padding: 18px 4px;
  color: #3d4537;
}

.e-source-text .is-entity {
  background: #f8eccb;
  border-radius: 3px;
  cursor: pointer;
}

.e-source-text .is-active {
  background: #ffc9a9;
  outline: 1px solid #df6a36;
}

.e-breadcrumbs {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.e-breadcrumbs button {
  border: 0;
  background: none;
  font-size: 12px;
  color: #858f7b;
  cursor: pointer;
  text-align: left;
}

.e-filters {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin: 12px 0;
}

.e-filters > input {
  grid-column: 1/-1;
}

.e-occurrences {
  max-height: 34vh;
  overflow: auto;
}

.e-occurrence {
  width: 100%;
  border: 1px solid #e7ebdf;
  background: #fff;
  padding: 12px;
  margin-bottom: 8px;
  border-radius: 8px;
  text-align: left;
  cursor: pointer;
  color: #3e4835;
}

.e-occurrence.is-active {
  border-color: #e77d4e;
  background: #fff6ef;
}

.e-occurrence__heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 13px;
}

.e-occurrence > small {
  display: block;
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.8;
  color: #7d8971;
  overflow-wrap: anywhere;
}

.e-occurrence strong {
  overflow-wrap: anywhere;
}

.e-editor, .e-complete, .e-manual, .e-attachments {
  border-top: 1px solid #e8ecdf;
  margin-top: 20px;
  padding-top: 14px;
}

.e-attachments article {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0;
  font-size: 12px;
  overflow-wrap: anywhere;
}

@media (max-width: 1250px) {
  .e-workbench {
    grid-template-columns: 230px minmax(0, 1fr);
  }
  .e-occurrence-panel {
    grid-column: 1/-1;
  }
  .e-occurrences {
    max-height: 400px;
  }
  .e-reviewer-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .e-metrics {
    gap: 8px;
  }
  .e-metrics article {
    padding: 14px 10px;
  }
  .e-metrics strong {
    font-size: 22px;
  }
  .e-metrics span {
    font-size: 12px;
  }
  .e-two-panel, .e-workbench, .e-source-list {
    grid-template-columns: 1fr;
  }
  .e-card {
    padding: 18px;
  }
  .e-workbench .e-tree {
    max-height: 300px;
  }
  .e-workbench .e-occurrence-panel {
    grid-column: auto;
  }
  .e-result-main {
    padding: 14px;
  }
  .e-reviewer-grid {
    grid-template-columns: 1fr;
  }
  .e-pagination {
    padding: 14px;
  }
  .e-pagination > div {
    gap: 8px;
  }
}
@media (max-width: 1050px) {
  .entity-page .project-ledger__table-wrap {
    display: none;
  }
  .e-list-cards {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .e-list-cards {
    grid-template-columns: 1fr;
  }
}
.review-workspace .review-current {
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border: 1px solid #d6dfcf;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 14px;
}
.review-workspace .review-current > div {
  min-width: 0;
}
.review-workspace .review-current h2 {
  font-size: 20px;
  line-height: 1.5;
  margin: 4px 0;
  overflow-wrap: anywhere;
}
.review-workspace .review-current p {
  margin: 5px 0;
  font-size: 13px;
  line-height: 1.7;
  color: #485540;
}
.review-workspace .review-current .review-project-progress {
  font-size: 12px;
}
.review-workspace .review-current .review-next {
  font-weight: 600;
}
.review-workspace .review-pane-nav {
  display: flex;
  gap: 8px;
  margin: 0 0 14px;
  flex-wrap: wrap;
}
.review-workspace .review-pane-nav button[aria-pressed=true] {
  color: #fff;
  background: #394b30;
  border-color: #394b30;
}
.review-workspace .review-compare {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
  gap: 18px;
  align-items: start;
}
.review-workspace .review-compare .e-occurrence-panel {
  grid-column: auto;
}
.review-workspace .e-card {
  padding: 20px;
  margin-bottom: 18px;
}
.review-workspace .e-card__header {
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.review-workspace .e-card h2 {
  font-size: 18px;
}
.review-workspace .review-guidance {
  padding: 10px 12px;
  background: #f2f6ee;
  color: #3f5036;
  font-size: 13px;
  line-height: 1.8;
  margin: 8px 0 14px;
  border-radius: 7px;
}
.review-workspace .e-source-text {
  max-height: 65vh;
  min-height: 120px;
  line-height: 28px;
  padding: 12px 8px;
  font-size: 16px;
  scrollbar-gutter: stable;
}
.review-workspace .e-source-text .is-entity {
  background: #f7ebbc;
  color: #343d2c;
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 3px;
}
.review-workspace .e-source-text .is-active {
  background: #ffd3b4;
  outline: 2px solid #9e4929;
}
.review-workspace .e-source-text [role=button]:focus-visible {
  outline: 3px solid #ae4327;
  outline-offset: 2px;
}
.review-workspace .e-editor {
  margin: 0 0 18px;
  padding: 14px;
  border: 2px solid #9e6c43;
  border-radius: 9px;
  background: #fffaf5;
}
.review-workspace .e-editor h3 {
  margin: 0;
  font-size: 16px;
}
.review-workspace blockquote {
  border-left: 3px solid #9e6c43;
  padding: 8px 12px;
  margin: 10px 0;
  font-size: 14px;
  line-height: 1.8;
  overflow-wrap: anywhere;
}
.review-workspace .e-field, .review-workspace .e-muted, .review-workspace .e-subtext, .review-workspace .e-occurrence > small {
  color: #4f5e46;
  font-size: 13px;
}
.review-workspace .e-field input, .review-workspace .e-field textarea, .review-workspace .e-filters input, .review-workspace .e-filters select {
  font-size: 14px;
  min-height: 44px;
  color: #303c29;
  border-color: #bac7af;
}
.review-workspace .e-button {
  min-height: 44px;
}
.review-workspace .e-text-button {
  min-height: 44px;
}
.review-workspace .e-badge {
  color: #40522d;
  font-size: 12px;
}
.review-workspace .review-candidate-list {
  margin-top: 12px;
}
.review-workspace .e-occurrence {
  padding: 12px;
}
.review-workspace .e-occurrence.is-active {
  border: 2px solid #9e4929;
}
.review-workspace .review-unsaved {
  font-size: 13px;
  font-weight: 600;
  color: #914119;
}
.review-workspace .review-completion {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 24px;
}
.review-workspace .review-completion p {
  line-height: 1.8;
  font-size: 13px;
  color: #485540;
}
.review-workspace .review-context {
  background: #fff;
  border: 1px solid #dce2d5;
  border-radius: 8px;
  padding: 16px;
  font-size: 13px;
  line-height: 1.8;
  overflow-wrap: anywhere;
}
.review-workspace summary {
  cursor: pointer;
  min-height: 44px;
  padding: 8px 0;
  color: #445339;
  font-size: 13px;
  font-weight: 600;
}
.review-workspace .review-action-help, .review-workspace .review-trace {
  font-size: 12px;
  line-height: 1.8;
  overflow-wrap: anywhere;
}
.review-workspace .review-candidate-filters {
  border-bottom: 1px solid #dce2d5;
}
.review-workspace .review-material-list {
  padding: 0;
  margin: 0;
  list-style: none;
}
.review-workspace .e-tree-title {
  min-height: 44px;
}
.review-workspace .e-tree-title small {
  color: #4f5e46;
}
.review-workspace .e-tree-toggle {
  height: 44px;
  width: 44px;
  flex-basis: 44px;
}
.review-workspace .e-tree-row.is-selected {
  border-left: 3px solid #a54b2a;
}
.review-workspace .e-manual {
  margin: 0 0 12px;
  padding: 14px;
  border: 1px solid #c1ceb6;
  border-radius: 8px;
  background: #f5f8f1;
}
.review-workspace .review-manual-matches {
  max-height: 260px;
  overflow: auto;
}
.review-workspace #review-current-title:focus, .review-workspace #review-source-title:focus, .review-workspace #review-candidates-title:focus, .review-workspace #review-editor-title:focus, .review-workspace #review-completion-title:focus {
  outline: 3px solid #ae4327;
  outline-offset: 4px;
}
.review-workspace #review-completion-title {
  scroll-margin-top: 20px;
}
.review-workspace input[type=search]::-webkit-search-cancel-button {
  display: none;
}
@media (max-width: 1023px) {
  .review-workspace .creation-header {
    height: auto !important;
    max-height: none !important;
  }
  .review-workspace .creation-header__inner {
    height: auto !important;
    max-height: none !important;
  }
}
@media (min-width: 1800px) {
  .review-workspace .review-compare {
    grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);
  }
}
@media (max-width: 1023px) {
  .review-workspace .review-compare {
    grid-template-columns: minmax(0, 1fr);
  }
  .review-workspace .review-mobile-hidden {
    display: none;
  }
  .review-workspace .review-current {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
  .review-workspace .review-completion {
    grid-template-columns: minmax(0, 1fr);
    gap: 4px;
  }
  .review-workspace #review-completion-title {
    scroll-margin-top: 112px;
  }
  .review-workspace .e-source-text {
    max-height: 58vh;
  }
  .review-workspace .review-pane-nav {
    position: sticky;
    top: 0;
    z-index: 5;
    padding: 8px 0;
    background: #f7f8f4;
  }
}
@media (max-width: 600px) {
  .review-workspace .e-card, .review-workspace .review-current {
    padding: 14px;
  }
  .review-workspace .review-current h2 {
    font-size: 18px;
  }
  .review-workspace .review-pane-nav {
    gap: 6px;
  }
  .review-workspace .review-pane-nav > button {
    flex: 1;
    padding: 10px 8px;
  }
  .review-workspace .e-source-text {
    font-size: 16px;
  }
  .review-workspace .e-editor {
    padding: 12px;
  }
  .review-workspace .e-actions > .e-button {
    flex-grow: 1;
  }
  .review-workspace .e-pagination {
    flex-wrap: wrap;
    gap: 8px;
  }
}

/* 11: workspace information hierarchy and shared component roles. */
:host-context(.reviewops-shell) .review-workspace .review-current {
  gap: 16px;
  margin-bottom: 16px;
  padding: 16px;
}
:host-context(.reviewops-shell) .review-workspace .review-compare {
  gap: 24px;
}
:host-context(.reviewops-shell) .review-workspace .review-pane-nav {
  position: static;
  padding: 0;
  margin-bottom: 16px;
}
:host-context(.reviewops-shell) .review-workspace .review-pane-nav button[aria-pressed=true] {
  color: #8F351D;
  background: #FFF0ED;
  border-color: var(--ro-accent);
}
:host-context(.reviewops-shell) .review-workspace .e-card {
  padding: 16px;
  margin-bottom: 24px;
}
:host-context(.reviewops-shell) .review-workspace .e-source-text {
  max-width: 80ch;
  max-height: 72vh;
  min-height: 240px;
  padding: 16px 8px;
  font-size: 16px;
  line-height: 28px;
}
:host-context(.reviewops-shell) .review-workspace .review-guidance {
  background: var(--ro-canvas);
  color: var(--ro-muted);
}
:host-context(.reviewops-shell) .review-workspace .review-unsaved {
  color: #7A4B00;
}
@media (max-width: 1023px) {
  :host-context(.reviewops-shell) .review-workspace .review-compare {
    gap: 16px;
  }
  :host-context(.reviewops-shell) .review-workspace .e-source-text {
    max-height: none;
  }
  :host-context(.reviewops-shell) .review-workspace #review-completion-title {
    scroll-margin-top: 16px;
  }
}`],
})
export class PageEntityReviewsItemComponent implements OnInit, OnDestroy {
    public item = decodeURIComponent(location.pathname.split('/')[2] || '');
    public tree = new EntityTree(this.item);
    public projectData: any = null;
    public current: any = null;
    public focused: any = null;
    public segments: any[] = [];
    private displayToRaw: number[] = [];
    public query = '';
    public keyword = '';
    public type = '';
    public decision = '';
    public occurrencePage = 1;
    public editSurface = '';
    public editType = '';
    public note = '';
    public nodeNote = '';
    public error = '';
    public treeError = '';
    public message = '';
    public loading = true;
    public nodeLoading = false;
    public busy = false;
    public refreshRequired = false;
    public pickerOpen = false;
    public view = 'source';
    public manual: any = null;
    public manualOpen = false;
    public manualQuery = '';
    public manualMatches: any[] = [];
    public manualSearched = false;
    public manualType = '';
    private searchTimer: any = null;
    private selectionVersion = 0;
    private searchVersion = 0;
    private life = 0;
    private destroyed = false;
    private focusCleanups = new Set<() => void>();
    private removeNavigationGuard = () => {};
    private leaving = false;
    private unload = (event: BeforeUnloadEvent) => { if (!this.leaving && (this.dirty() || this.busy)) { event.preventDefault(); event.returnValue = ''; } };
    constructor(@Inject( Service) public service: Service,@Inject( ActivatedRoute)  private route: ActivatedRoute) { }
    async ngOnInit() {
        // Only this mounted route receives a guard. Preserve other guards and
        // remove our own function on destroy; no shared routing/auth changes.
        const config = this.route?.snapshot.routeConfig;
        if (config) {
            const previous = config.canDeactivate;
            const guard = () => this.leaving || this.discard();
            config.canDeactivate = [...(config.canDeactivate || []),guard];
            this.removeNavigationGuard = () => {
                const rest = config.canDeactivate?.filter(g => g !== guard);
                config.canDeactivate = rest?.length === (previous?.length || 0) && rest.every((g,i) => g === previous?.[i]) ? previous : rest;
            };
        }
        window.addEventListener('beforeunload', this.unload);
        await this.service.init();
        if (!this.destroyed) await this.load();
    }
    ngOnDestroy() {
        this.destroyed = true; this.life++; this.selectionVersion++; this.searchVersion++;
        clearTimeout(this.searchTimer); this.removeNavigationGuard(); window.removeEventListener('beforeunload', this.unload);
        for (const cleanup of [...this.focusCleanups]) cleanup();
    }
    async load() {
        const life = ++this.life;
        this.loading = true; this.error = '';
        try {
            const data = await EntityApi.request('detail', {item:this.item});
            if (this.destroyed || life !== this.life) return;
            this.projectData = data;
            await this.tree.reset('', () => !this.destroyed && life === this.life);
            if (this.destroyed || life !== this.life) return;
            const id = new URLSearchParams(location.search).get('node') || data.first_node_id;
            if (id) await this.select({id}, true);
        } catch (e: any) { if (!this.destroyed && life === this.life) this.error = e.message; }
        finally { if (!this.destroyed && life === this.life) { this.loading = false; await this.service.render(); } }
    }
    // An explicit action may move focus after rendering. Any intervening focus on
    // another control cancels that intent, including moving away and back.
    private focusIntent(event?: Event) {
        const origin = event?.currentTarget as HTMLElement | null;
        if (!origin || !origin.isConnected || (origin as any).disabled) return {finish: (_id: string, _action?: () => void) => {}, cancel: () => {}};
        let cancelled = false;
        const moved = (e: Event) => { if (e.target !== origin && e.target !== document.body && e.target !== document.documentElement) cancelled = true; };
        const cleanup = () => { document.removeEventListener('focusin', moved); this.focusCleanups.delete(cleanup); };
        document.addEventListener('focusin', moved); this.focusCleanups.add(cleanup);
        return { finish: (id: string, action?: () => void) => {
            const active = document.activeElement;
            const allowed = !cancelled && !this.destroyed && (!active || active === origin || active === document.body || active === document.documentElement);
            cleanup();
            if (allowed) { action?.(); document.getElementById(id)?.focus(); }
        }, cancel: cleanup };
    }
    search() {
        clearTimeout(this.searchTimer);
        const version = ++this.searchVersion, life = this.life, run = this.projectData?.project.active_run;
        const valid = () => !this.destroyed && version === this.searchVersion && life === this.life && run === this.projectData?.project.active_run;
        const tree = new EntityTree(this.item); this.tree = tree; tree.query = this.query.trim();
        this.treeError = ''; tree.loading = true;
        this.searchTimer = window.setTimeout(async () => {
            try { await tree.reset(this.query.trim(),valid); }
            catch (e: any) { if (valid()) this.treeError = e.message; }
            finally { if (valid()) { this.tree.loading = false; await this.service.render(); } }
        },300);
    }
    clearSearch() { this.query = ''; this.search(); }
    async toggle(row: any) {
        const life = this.life, search = this.searchVersion, tree = this.tree, run = this.projectData?.project.active_run;
        const valid = () => !this.destroyed && life === this.life && search === this.searchVersion && tree === this.tree && run === this.projectData?.project.active_run;
        this.treeError = '';
        try { await this.tree.toggle(row,valid); } catch (e: any) { if (valid()) this.treeError = e.message; }
        if (valid()) await this.service.render();
    }
    candidateDirty() {
        return !!this.focused && (this.editSurface !== (this.focused.edited_surface ?? this.focused.surface) || this.editType !== (this.focused.edited_type ?? this.focused.raw_type) || this.note !== (this.focused.note || ''));
    }
    dirty() { return this.candidateDirty() || !!this.manual || !!this.manualQuery || !!this.manualType || (!!this.current && this.nodeNote !== (this.current.review.note || '')); }
    private discard(candidateOnly = false) {
        if (this.busy) return false;
        const dirty = candidateOnly ? this.candidateDirty() || !!this.manual : this.dirty();
        return !dirty || window.confirm('아직 저장하지 않은 입력이 있습니다. 입력을 버리고 이동할까요? 취소하면 계속 검수할 수 있습니다.');
    }
    leave(event: MouseEvent) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
        if (!this.discard()) event.preventDefault(); else this.leaving = true;
    }
    async select(row: any, reveal = false, event?: Event) {
        if (row.more) return this.toggle(row);
        if (!this.discard()) return;
        const version = ++this.selectionVersion, life = this.life;
        const valid = () => !this.destroyed && version === this.selectionVersion && life === this.life;
        const intent = this.focusIntent(event);
        this.nodeLoading = true; this.error = ''; this.message = '';
        try {
            const data = await EntityApi.request('node',{item:this.item,node:row.id});
            if (!valid()) return;
            this.current = data; this.focused = null; this.manual = null; this.manualQuery = ''; this.manualType = ''; this.manualMatches = []; this.manualSearched = false; this.manualOpen = false;
            this.keyword = ''; this.type = ''; this.decision = ''; this.occurrencePage = 1;
            this.nodeNote = data.review.note || ''; this.refreshRequired = false; this.buildSegments();
            const params = new URLSearchParams(location.search); params.set('node',row.id);
            history.replaceState(history.state,'',location.pathname+'?'+params);
            if (reveal && !this.tree.query) for (const crumb of data.breadcrumbs) {
                if (!valid()) return;
                const parent = this.tree.rows.find(r => r.id === crumb.id);
                if (parent && !parent.expanded) await this.tree.toggle(parent,valid);
            }
            if (!valid()) return;
            // Default/URL restoration does not close the picker or move focus.
            if (event) { this.pickerOpen = false; this.view = 'source'; }
        } catch (e: any) { if (valid()) this.error = e.message; }
        finally {
            if (valid()) {
                this.nodeLoading = false; await this.service.render();
                if (valid() && event) intent.finish('review-current-title'); else intent.cancel();
            } else intent.cancel();
        }
    }
    async showView(view: string, event: Event) {
        const intent = this.focusIntent(event), version = this.selectionVersion;
        this.view = view; await this.service.render();
        if (version === this.selectionVersion) intent.finish(view === 'source' ? 'review-source-title' : 'review-candidates-title'); else intent.cancel();
    }
    async openPicker(event: Event) {
        const intent = this.focusIntent(event);
        this.pickerOpen = !this.pickerOpen; await this.service.render();
        intent.finish(this.pickerOpen ? 'review-material-search' : 'review-current-title');
    }
    showCompletion() {
        if (!this.current || this.nodeLoading || this.destroyed) return;
        // The completion section is already rendered. Keep this action synchronous
        // so a later user focus change cannot be overridden by queued work.
        const title = document.getElementById('review-completion-title');
        title?.focus({preventScroll:true});
        title?.scrollIntoView({block:'start',behavior:'auto'});
    }
    nextTask() {
        if (!this.current) return '자료를 먼저 선택하세요.';
        const n = this.current.node;
        if (!this.current.can_review) return '열람만 가능합니다. 저장 권한을 확인해 주세요.';
        if (!n.body_chars && !n.index_count && n.child_count) return '다음 할 일: 자료 바꾸기·찾기에서 본문이 있는 하위 자료를 고르세요.';
        if (n.pdf_count) return '원문과 후보를 확인하세요. PDF 본문 확인 기능이 연결되기 전에는 이 자료를 완료할 수 없습니다.';
        if (!n.body && !this.current.occurrences.length) return '표시할 본문이 없습니다. 자료 준비 상태를 확인해 주세요.';
        return this.pending() ? '다음 할 일: 후보를 선택해 원문과 대조하고 저장하세요.' : '다음 할 일: 원문을 읽고 빠진 표현과 완료 조건을 확인하세요.';
    }
    nodeStatus(n: any) {
        if (n.review_status === 'completed') return '검수 완료';
        if (n.index_count) return '기존 태그 '+Number(n.index_count).toLocaleString()+'건';
        if (n.pdf_count) return n.body_chars ? '본문·PDF 확인 필요' : 'PDF만 · 본문 확인 필요';
        if (n.body_chars) return '기존 태그 없음 · 본문 확인';
        return n.child_count ? '목차 · 하위 자료 선택' : '본문 없는 자료';
    }
    filtered() {
        const q = this.keyword.trim().toLowerCase();
        return (this.current?.occurrences || []).filter((o: any) => (!q || o.surface.toLowerCase().includes(q) || (o.edited_surface || '').toLowerCase().includes(q)) && (!this.type || this.typeValue(o.raw_type) === this.type) && (!this.decision || o.decision === this.decision));
    }
    paged() { return this.filtered().slice((this.occurrencePage-1)*10,this.occurrencePage*10); }
    occurrencePages() { return Math.max(1,Math.ceil(this.filtered().length/10)); }
    typeValue(value: any) { return JSON.stringify(value || ''); }
    types() { return [...new Set((this.current?.occurrences || []).map((o: any) => o.raw_type))].sort(); }
    pending() { return (this.current?.occurrences || []).filter((o: any) => o.decision === 'pending').length; }
    decisionLabel(v: string) { return ({pending:'확인 대기',accepted:'그대로 확인됨',corrected:'수정 저장됨',excluded:'제외됨'} as any)[v] || v; }
    resetFilters() { this.keyword = ''; this.type = ''; this.decision = ''; this.occurrencePage = 1; }
    async candidatePage(page: number, event: Event) {
        const intent = this.focusIntent(event); this.occurrencePage = Math.max(1,Math.min(page,this.occurrencePages()));
        await this.service.render(); intent.finish('review-candidates-title');
    }
    buildSegments() {
        const chars = Array.from(String(this.current?.node.body || ''));
        const focus = this.focused;
        const spans = (this.current?.occurrences || []).filter((o: any) => o.end > o.start && (!focus || o.id === focus.id || o.end <= focus.start || o.start >= focus.end)).slice().sort((a: any, b: any) => a.start - b.start);
        this.segments = []; this.displayToRaw = []; let end = 0;
        const add = (start: number, finish: number, id = '', active = false) => {
            let text = '';
            for (let i = start; i < finish; i++) {
                if (!id && /\s/.test(chars[i])) {
                    let j = i + 1;
                    while (j < finish && /\s/.test(chars[j])) j++;
                    if (i > 0 && j < chars.length) {
                        text += chars.slice(i, j).includes('\n') ? '\n' : ' ';
                        this.displayToRaw.push(i);
                    }
                    i = j - 1;
                } else { text += chars[i]; this.displayToRaw.push(i); }
            }
            if (text) this.segments.push({ text, id, active });
        };
        for (const span of spans) {
            if (span.start < end) continue;
            if (span.start > end) add(end, span.start);
            add(span.start, span.end, span.id, span.id === focus?.id);
            end = span.end;
        }
        if (end < chars.length) add(end, chars.length);
    }
    private edit(occurrence: any) {
        this.focused = occurrence; this.editSurface = occurrence.edited_surface ?? occurrence.surface;
        this.editType = occurrence.edited_type ?? occurrence.raw_type; this.note = occurrence.note || '';
    }
    async focus(occurrence: any, event?: Event) {
        if (!this.discard(true)) return;
        const intent = this.focusIntent(event), version = this.selectionVersion;
        this.manual = null; this.edit(occurrence); this.buildSegments(); this.view = 'review';
        await this.service.render();
        if (version !== this.selectionVersion || this.focused?.id !== occurrence.id) { intent.cancel(); return; }
        intent.finish('review-editor-title', () => this.scrollSource(occurrence.id));
    }
    async focusId(id: string, event?: Event) { const o = this.current?.occurrences.find((o: any) => o.id === id); if (o) await this.focus(o,event); }
    private scrollSource(id: string) {
        const target = document.getElementById('entity-span-'+id), panel = document.getElementById('entity-source-text');
        if (target && panel) panel.scrollTo({top:panel.scrollTop+target.getBoundingClientRect().top-panel.getBoundingClientRect().top-panel.clientHeight/3,behavior:'auto'});
    }
    async showSource(event: Event) {
        const intent = this.focusIntent(event), id = this.focused?.id, version = this.selectionVersion;
        this.view = 'source'; await this.service.render();
        if (version === this.selectionVersion && id === this.focused?.id) intent.finish('entity-span-'+id,() => this.scrollSource(id)); else intent.cancel();
    }
    async refreshCurrent(focusId = '') {
        if (this.destroyed) return;
        const version = this.selectionVersion, id = this.current.node.id, life = this.life;
        const valid = () => !this.destroyed && version === this.selectionVersion && life === this.life && this.current?.node.id === id;
        const data = await EntityApi.request('node',{item:this.item,node:id});
        if (!valid()) return;
        this.current = data;
        const focus = data.occurrences.find((o: any) => o.id === focusId);
        if (focus) this.edit(focus); else this.focused = null;
        this.buildSegments(); this.occurrencePage = Math.min(this.occurrencePage,this.occurrencePages());
        const row = this.tree.rows.find(r => r.id === id); if (row) row.review_status = data.review.status;
        const detail = await EntityApi.request('detail',{item:this.item});
        if (!valid()) return;
        this.projectData = detail; window.dispatchEvent(new Event('reviewops:entity-updated'));
    }
    private writable() { return !!this.current?.can_review && !this.nodeLoading && !this.busy && !this.refreshRequired && !this.destroyed; }
    async save(decision: string) {
        if (!this.focused || !this.writable() || !['accepted','corrected','excluded','pending'].includes(decision)) return;
        if (decision === 'corrected' && (!this.editSurface.trim() || !this.editType.trim())) { this.error = '수정할 표현과 유형을 입력해 주세요.'; return; }
        if (decision !== 'corrected' && (this.editSurface !== (this.focused.edited_surface ?? this.focused.surface) || this.editType !== (this.focused.edited_type ?? this.focused.raw_type)) && !window.confirm('이 동작은 입력한 수정 표현·유형을 저장하지 않고 원본 표현·유형을 사용합니다. 계속할까요?')) return;
        this.busy = true; this.error = ''; this.message = '';
        const life = this.life, id = this.focused.id; let saved = false;
        try {
            await EntityApi.request('',{}, {action:'review',item_id:this.item,node_id:this.current.node.id,run_id:this.current.run_id,occurrence_id:id,decision,revision:this.focused.revision,surface:this.editSurface,type:this.editType,note:this.note});
            saved = true; if (this.destroyed || life !== this.life) return;
            await this.refreshCurrent(id);
            if (!this.destroyed && life === this.life) this.message = this.decisionLabel(decision)+' · 저장했습니다.';
        } catch (e: any) { if (!this.destroyed && life === this.life) { this.error = e.message; this.refreshRequired = saved; if (saved) this.message = '저장 요청은 성공했지만 최신 결과를 확인하지 못했습니다. 다시 불러온 뒤 계속하세요.'; } }
        finally { if (!this.destroyed && life === this.life) { this.busy = false; await this.service.render(); } }
    }
    captureSelection() {
        if (!this.writable()) return;
        const selection = window.getSelection(), root = document.getElementById('entity-source-text');
        if (!selection || !selection.rangeCount || selection.isCollapsed || !root) return;
        const range = selection.getRangeAt(0);
        if (!root.contains(range.startContainer) || !root.contains(range.endContainer)) return;
        const prefix = range.cloneRange(); prefix.selectNodeContents(root); prefix.setEnd(range.startContainer,range.startOffset);
        const displayStart = Array.from(prefix.toString()).length, text = range.toString(), displayEnd = displayStart+Array.from(text).length;
        const start = this.displayToRaw[displayStart], end = this.displayToRaw[displayEnd-1]+1;
        const original = Array.from(String(this.current.node.body)).slice(start,end).join('');
        if (Number.isInteger(start) && Number.isInteger(end) && original.replace(/\s+/g,' ') === text.replace(/\s+/g,' ') && text.trim() && this.discard(true)) {
            this.manual = {start,end,text:original}; this.manualOpen = true; void this.service.render();
        }
    }
    findManual() {
        const body = String(this.current?.node.body || ''), text = this.manualQuery;
        this.manualMatches = []; this.manualSearched = true;
        if (!text.trim()) return;
        let at = 0;
        while (this.manualMatches.length < 50) {
            const i = body.indexOf(text,at); if (i < 0) break;
            const start = Array.from(body.slice(0,i)).length, end = start+Array.from(text).length;
            this.manualMatches.push({start,end,text,before:body.slice(Math.max(0,i-30),i),after:body.slice(i+text.length,i+text.length+30)});
            at = i+text.length;
        }
    }
    chooseManual(match: any) { if (this.writable() && this.discard(true)) this.manual = {start:match.start,end:match.end,text:match.text}; }
    cancelManual(event?: Event) {
        const origin = event?.currentTarget as HTMLButtonElement | null;
        const form = document.getElementById('review-manual');
        if (!this.destroyed && !this.nodeLoading && !this.busy && this.current && this.manualOpen &&
            origin?.isConnected && !origin.disabled && form?.contains(origin) && form.contains(document.activeElement)) {
            // Move before Angular removes the focused control. No queued return can
            // override a later user action, new material or a destroyed view.
            const target = ['review-manual-open','review-source-title'].map(id => document.getElementById(id)).find(el =>
                el?.isConnected && !(el as HTMLButtonElement).disabled && form.parentElement?.contains(el) && el.getClientRects().length);
            target?.focus();
        }
        // Calls after saving have no UI event and only clear the manual draft.
        this.manual = null; this.manualOpen = false; this.manualQuery = ''; this.manualType = ''; this.manualMatches = []; this.manualSearched = false;
    }
    async addManual() {
        if (!this.manual || !this.manualType.trim() || !this.writable()) return;
        this.busy = true; this.error = ''; this.message = '';
        const life = this.life; let saved = false;
        try {
            const result = await EntityApi.request('',{}, {action:'manual_add',item_id:this.item,node_id:this.current.node.id,run_id:this.current.run_id,start:this.manual.start,end:this.manual.end,type:this.manualType});
            saved = true; if (this.destroyed || life !== this.life) return;
            this.cancelManual(); await this.refreshCurrent(result.id); this.view = 'review';
            if (!this.destroyed && life === this.life) this.message = '누락 후보를 저장했습니다. 아직 확인 대기 상태입니다. 내용을 확인해 주세요.';
        } catch (e: any) { if (!this.destroyed && life === this.life) { this.error = e.message; this.refreshRequired = saved; if (saved) this.message = '후보 추가는 성공했습니다. 최신 결과를 다시 불러와 주세요.'; } }
        finally { if (!this.destroyed && life === this.life) { this.busy = false; await this.service.render(); } }
    }
    completionReason() {
        if (!this.current) return '자료를 먼저 선택하세요.';
        if (this.refreshRequired) return '최신 결과를 다시 불러와 주세요.';
        if (!this.current.can_review) return '이 자료를 저장할 권한이 없습니다. 관리자에게 배정을 확인해 주세요.';
        if (this.current.node.pdf_count) return 'PDF 본문 확인 기능이 아직 연결되지 않아 이 자료는 완료할 수 없습니다.';
        if (!this.current.node.body_chars && !this.current.node.index_count) return this.current.node.child_count ? '목차입니다. 본문이 있는 하위 자료를 선택하세요.' : '완료할 본문·기존 태그가 없는 자료입니다.';
        if (this.pending()) return '확인 대기 후보 '+this.pending()+'건을 먼저 확인·수정·제외해 주세요.';
        if (this.candidateDirty() || this.manual || this.manualQuery || this.manualType) return '후보 입력을 먼저 저장하거나 취소해 주세요.';
        if (this.current.review.status === 'completed') return '이미 완료된 자료입니다. 후보를 다시 저장하면 확인 대기로 돌아갑니다.';
        return '';
    }
    async complete() {
        if (!this.writable() || this.completionReason()) return;
        this.busy = true; this.error = ''; this.message = '';
        const life = this.life; let saved = false;
        try {
            await EntityApi.request('',{}, {action:'complete_node',item_id:this.item,node_id:this.current.node.id,run_id:this.current.run_id,revision:this.current.review.revision,note:this.nodeNote});
            saved = true; if (this.destroyed || life !== this.life) return;
            await this.refreshCurrent();
            if (!this.destroyed && life === this.life) this.message = '이 자료의 검수를 완료했습니다.';
        } catch (e: any) { if (!this.destroyed && life === this.life) { this.error = e.message; this.refreshRequired = saved; if (saved) this.message = '완료 요청은 성공했습니다. 최신 상태를 다시 불러와 주세요.'; } }
        finally { if (!this.destroyed && life === this.life) { this.busy = false; await this.service.render(); } }
    }
    assignment() {
        if (!this.current || !this.projectData) return '';
        const ids = [this.current.node.id,...this.current.breadcrumbs.slice().reverse().map((n: any) => n.id)];
        for (const id of ids) {
            const a = this.projectData.assignments.find((a: any) => a.node_id === id);
            if (a) return (id === this.current.node.id ? '이 자료에 지정: ' : '상위 자료에서 적용: ')+(a.reviewers.map((r: any) => r.name).join(', ') || '지정 없음');
        }
        return '프로젝트 기본 배정: '+(this.projectData.project.reviewers.map((r: any) => r.name).join(', ') || '지정 없음');
    }
    projectReturnUrl() {
        const value = new URLSearchParams(location.search).get('returnTo');
        const path = '/entity-projects/' + encodeURIComponent(this.item);
        if (!value || /[\\\r\n#]/.test(value)) return null;
        try {
            const url = new URL(value, location.origin);
            if (url.origin !== location.origin || url.pathname !== path || !value.startsWith(path + '?') && value !== path) return null;
            if ([...url.searchParams.keys()].some(key => key !== 'node' && key !== 'q')) return null;
            if (url.searchParams.getAll('node').length > 1 || url.searchParams.getAll('q').length > 1) return null;
            return path + url.search;
        } catch { return null; }
    }
    backLabel() { return this.projectReturnUrl() ? '프로젝트 · 선택 자료로 돌아가기' : '개체명 검수 목록'; }
    listUrl() {
        const project = this.projectReturnUrl();
        if (project) return project;
        const param = new URLSearchParams(location.search).get('returnTo');
        if (param && /^\/entity-reviews(?:\?[^#]*)?$/.test(param)) return param;
        try { const s = sessionStorage.getItem('entity-reviews:return'); if (s && /^\/entity-reviews(?:\?[^#]*)?$/.test(s)) return s; } catch { }
        return '/entity-reviews';
    }
    exportUrl() { return '/api/v1/entity-review?op=export&item='+encodeURIComponent(this.item); }
}

export default PageEntityReviewsItemComponent;